import { useState } from 'react'
import { ChevronDown, SlidersHorizontal } from 'lucide-react'
import { cn } from '@/utils/cn'
import ContatoSection from './FormSections/ContatoSection'
import IntelligenceSection from './FormSections/IntelligenceSection'
import NecessitiesSection from './FormSections/NecessitiesSection'
import type { CloserLeadFormData } from '@/types'

type CloserLeadOptionalFieldsProps = {
  formData: CloserLeadFormData
  onFieldChange: (field: string, value: unknown) => void
  onMultiFieldChange: (fields: Partial<CloserLeadFormData>) => void
  errors: Record<string, string>
  defaultOpen?: boolean
}

export function CloserLeadOptionalFields({
  formData,
  onFieldChange,
  onMultiFieldChange,
  errors,
  defaultOpen = false,
}: CloserLeadOptionalFieldsProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className='overflow-hidden rounded-2xl border border-[color:var(--border)] bg-[var(--bg-card)]'>
      <button
        type='button'
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        className='flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left transition-colors hover:bg-[var(--glass-bg)] sm:px-5'
      >
        <div className='flex min-w-0 items-center gap-2.5'>
          <div className='rounded-lg bg-[var(--glass-bg)] p-1.5 text-[var(--text-muted)]'>
            <SlidersHorizontal size={15} />
          </div>
          <div className='min-w-0'>
            <p className='text-[13px] font-semibold text-[var(--text-primary)]'>Detalhes adicionais</p>
            <p className='text-[11px] text-[var(--text-muted)]'>
              Opcional — cargo, e-mail, qualificação e contexto comercial
            </p>
          </div>
        </div>
        <ChevronDown
          size={18}
          className={cn('shrink-0 text-[var(--text-muted)] transition-transform duration-300', open && 'rotate-180')}
        />
      </button>

      <div
        className={cn(
          'grid transition-[grid-template-rows] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]',
          open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        )}
      >
        <div className='overflow-hidden'>
          <div className='space-y-8 border-t border-[color:var(--border)] px-4 py-5 sm:px-5'>
            <ContatoSection
              formData={formData}
              onFieldChange={onFieldChange}
              onMultiFieldChange={onMultiFieldChange}
              errors={errors}
              fields='optional'
            />
            <IntelligenceSection formData={formData} onFieldChange={onFieldChange} errors={errors} />
            <NecessitiesSection formData={formData} onFieldChange={onFieldChange} />
          </div>
        </div>
      </div>
    </div>
  )
}
